/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FieldType {
    Text = 0,
    Tel = 1,
    Email = 2,
    Number = 3,
}
